import {
  Component,
  ChangeDetectionStrategy,
  AfterViewInit,
  EventEmitter,
  ViewChild,
  Output,
  ElementRef,
} from '@angular/core';
import { ComponentInOutAnimation } from '../../util/component-base-animation';
import SignaturePad from 'signature_pad';
import { TimeZoneDateFormatterService } from '@fullyops/shared/services/date-formatter.service';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';

@Component({
  selector: 'fo-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss'],
  animations: [ComponentInOutAnimation.AnimTrigger],
  imports: [MaterialModule, I18NextCapPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignaturePadComponent implements AfterViewInit {
  constructor(public timezoneDate: TimeZoneDateFormatterService) {}
  @Output() changeEvent = new EventEmitter<Blob>();

  @ViewChild('sPad', { static: true })
  signaturePadElement: ElementRef<HTMLCanvasElement>;
  private signaturePad: SignaturePad;

  ngAfterViewInit(): void {
    this.resizeCanvas();
    this.signaturePad = new SignaturePad(
      this.signaturePadElement.nativeElement,
    );

    this.signaturePad.onEnd = (event) => {
      this.send();
    };
  }

  private resizeCanvas(): void {
    const canvas = this.signaturePadElement.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
  }

  clear() {
    this.signaturePad.clear();
    this.changeEvent.emit(null);
  }

  b64toFile(dataURI: string): Blob {
    // convert the data URL to a byte string
    const byteString = atob(dataURI.split(',')[1]);

    // pull out the mime type from the data URL
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // Convert to byte array
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // Create a blob that looks like a file.
    const blob = new Blob([ab], { type: mimeString });
    blob['lastModifiedDate'] = this.timezoneDate.currentDate().toISOString();
    blob['name'] = 'file';

    // Figure out what extension the file should have
    switch (blob.type) {
      case 'image/jpeg':
        blob['name'] += '.jpg';
        break;
      case 'image/png':
        blob['name'] += '.png';
        break;
    }
    // cast to a File
    return blob;
  }

  send() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL();
      this.changeEvent.emit(this.b64toFile(dataURL));
    }
  }
}
